import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "What problems can physiotherapy treat?",
    a: "Physiotherapy effectively treats back & neck pain, joint problems, sciatica, sports injuries, post-surgery recovery, paralysis rehabilitation, frozen shoulder, knee pain and posture issues — among many other conditions.",
  },
  {
    q: "How many sessions do I need?",
    a: "Most conditions benefit from a 7–21 day treatment plan, with the exact number tailored to your assessment, severity, and recovery goals.",
  },
  {
    q: "Do you provide home visits?",
    a: "Yes — Neuro Rehabs specialises in home-visit physiotherapy so you can recover in the comfort of your own home, with all equipment brought by the doctor.",
  },
  {
    q: "Is physiotherapy painful?",
    a: "Modern physiotherapy is gentle and progressive. You may feel mild soreness initially, but pain is never the goal — comfort and steady recovery are.",
  },
  {
    q: "What are the consultation timings?",
    a: "Clinic is open Monday to Saturday, 8 AM to 9 PM. Sunday is closed for appointments. WhatsApp support is available 24×7.",
  },
];

export const FAQ = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="py-20 sm:py-28 lg:py-32 bg-slate-50/60"
  >
    <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="text-center">
        <p className="text-xs sm:text-sm text-brand-600 font-semibold tracking-[0.18em] uppercase">
          FAQ
        </p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
          Frequently asked questions
        </h2>
        <p className="mt-4 text-lg text-slate-600">
          Everything you need to know before booking your first session.
        </p>
      </div>

      <Accordion type="single" collapsible className="mt-10 sm:mt-14 space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="bg-white border border-slate-100 rounded-2xl px-6 shadow-[0_4px_20px_rgba(0,0,0,0.02)]"
          >
            <AccordionTrigger className="text-left text-base sm:text-lg font-medium text-slate-900 hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
